import React, { useState } from "react";
import { Mail, Copy, Check, ShieldAlert } from "lucide-react";
import { getOrgContactEmail, getOrgName } from "../utils/orgAdminAccess";

const ContactAdminBanner = ({ user, className = "" }) => {
  const [copied, setCopied] = useState(false);
  const contactEmail = getOrgContactEmail(user);
  const orgName = getOrgName(user);

  const subject = encodeURIComponent("Subscription Plan Upgrade Request");
  const body = encodeURIComponent(
    `Hi Admin,\n\nI would like to request an upgrade to our subscription plan on SPACIA for ${orgName} so that our team can access additional features.\n\nThank you!`
  );
  const mailtoLink = contactEmail
    ? `mailto:${contactEmail}?subject=${subject}&body=${body}`
    : null;

  const handleCopy = () => {
    if (!contactEmail) return;
    navigator.clipboard.writeText(contactEmail);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div
      className={`rounded-2xl border border-gray-200/90 bg-white shadow-sm p-6 transition-all ${className}`}
    >
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-5">
        <div className="flex items-start gap-4">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gray-100 text-gray-900 border border-gray-200/80">
            <ShieldAlert className="w-5 h-5 text-gray-700" />
          </div>
          <div>
            <div className="flex items-center gap-2.5 flex-wrap">
              <h3 className="text-base font-bold text-gray-900 tracking-tight">
                Organization Admin Required
              </h3>
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-700 border border-gray-200">
                View Only
              </span>
            </div>
            <p className="text-sm text-gray-600 mt-1 leading-relaxed max-w-2xl">
              You are exploring available plans for{" "}
              <span className="font-semibold text-gray-900">{orgName}</span>. Contact your
              administrator to initiate or upgrade a subscription.
            </p>
          </div>
        </div>

        {contactEmail && (
          <div className="flex items-center gap-2.5 self-stretch md:self-auto justify-end shrink-0 pt-2 md:pt-0">
            <div className="flex items-center gap-2 px-3.5 py-2 bg-gray-50 border border-gray-200 rounded-lg text-xs font-medium text-gray-700">
              <span className="select-all">{contactEmail}</span>
              <button
                type="button"
                onClick={handleCopy}
                className="text-gray-400 hover:text-gray-700 p-0.5 rounded transition-colors"
                title="Copy admin email"
              >
                {copied ? (
                  <Check className="w-3.5 h-3.5 text-green-600" />
                ) : (
                  <Copy className="w-3.5 h-3.5" />
                )}
              </button>
            </div>
            {mailtoLink && (
              <a
                href={mailtoLink}
                className="inline-flex items-center justify-center px-4 py-2 text-xs font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-lg shadow-sm transition-colors whitespace-nowrap"
              >
                <Mail className="w-3.5 h-3.5 mr-1.5" />
                Email Admin
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactAdminBanner;
